const parseError = (error) => {
    var _a, _b, _c, _d;
    if (error && typeof error === 'object' && 'response' in error) {
        const axiosError = error;
        const msg = ((_b = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) ||
            ((_d = (_c = axiosError.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message) ||
            axiosError.message ||
            'Error';
        return msg.replace(/^Error:\s*/, '');
    }
    if (error instanceof Error)
        return error.message.replace(/^Error:\s*/, '');
    return 'Error';
};
export default parseError;
